import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
	groupListReducer,
	groupListHomeAddReducer,
	groupAddReducer,
	groupDeleteReducer,
	bulkGroupAddReducer,
	groupTriggerReducer,
	groupListBySiteReducer,
	groupCountryListBySiteReducer,
	sidebarSearchReducer,
	viewModeReducer,
	refreshGroupSummaryReducer,
} from './groupReducers';
import {
	adminDetailReducer,
	changePasswordReducer,
	otpVerificationReducer,
	userAddReducer,
	userDeleteReducer,
	userEditReducer,
	userListReducer,
	userLoginReducer,
	userLogoutReducer,
	emailVerifyReducer,
	OtpVerifyReducer,
	userReducer,
	userSuspendReducer,
	userTriggerReducer,
	createTenantReducer,
	tenantListReducer,
	tenantDeleteReducer,
	tenantAddReducer,
	tenantDownloadReducer,
	tenantEditReducer,
	cnmsHostListReducer,
	tenantNotificationReducer,
	notificationTenantReducer,
	signupDataReducer,
} from './userReducers';
import { macAclListReducer } from './globalProfiles/macAclReducer';
import { vlanPoolListReducer } from './globalProfiles/vlanPoolReducers';
import { siteBackupReducer } from './siteBackup/siteBackupreducers';
import { clientDashboardReducer, clientListReducer, clientModalsReducer, topologyClientListReducer } from './clientReducers';
import { clientDashboardPersistMiddleware } from '../middlewares/persistMiddleware.js';
import {
	acsScheduleAddReducer,
	acsScheduleEditReducer,
	acsSchedulerListReducer,
} from './globalProfiles/acsSchedulerReducer';
import {
	accessPointDeleteReducer,
	accessPointListReducer,
	bulkAddApReducer,
	apTriggerReducer,
	accessPointAddReducer,
	accessPointUpdateReducer,
	moveApReducer,
	criticalAlarmTriggerReducer,
	deviceListBySiteReducer,
	apSwitchListReducer,
	accessPointDashboardReducer,
	configAuditListReducer,
	nestedChildListBySiteReducer,
	apSnapshotNavigateReducer
} from './accessPointReducers';
import {
	ssidScheduleAddReducer,
	ssidScheduleEditReducer,
	ssidSchedulerListReducer,
} from './globalProfiles/ssidSchedulerReducer';
import {
	SsidTemplateListReducer,
} from './globalProfiles/ssidTemplateReducer';
import { SSIDReducer, ssidTriggerReducer } from './ssidReducer';
import {
	roleAddReducer,
	roleDeleteReducer,
	roleDetailsReducer,
	roleEditReducer,
	roleListReducer,
	rolePermissionsReducer,
	roleReducer,
} from './roleReducers';
import { topologyModalsReducer, topologyReducer } from './topologyReducer';
import {
	atfProfileEditReducer,
	atfProfileListReducer,
} from './globalProfiles/atfProfileReducer';
import { breadcrumbsReducer } from './breadcrumbsReducers';
import {
	multiPSKListReducer,
	viewMultiPskReducer,
} from './globalProfiles/multiPSKReducer';
import { eogreReducer } from './globalProfiles/eogreReducers';
import {
	natAddProfileReducer,
	natAddTriggerReducer,
	natEditProfileReducer,
	natProfileReducer,
} from './globalProfiles/natProfileReducer';
import {
	aaaServerReducer,
	aaaServerTriggerReducer,
	aaaServerAddReducer,
	aaaServerEditReducer,
} from './globalProfiles/aaaServerReducers';
import { firmwareManagementListReducer } from './firmwareManagement/managementReducers';
import {
	deviceListReducer,
	firmwareListReducer,
	firmwareNavigatiorReducer,
	switchFirmwareListReducer,
} from './firmwareManagement/firmwareReducers';
import { auditLogListReducer } from './maintainance/auditLogReducer.';
import { tourGuideReducer, tourGuideStepReducer } from './tourGuideReducers';
import { contentTypeListReducer } from './contentTypeReducer';
import { hiSenseGraphReducer } from './graphReducers/hiSenseGraphReducers';
import { customerAggrStatsReducer } from './graphReducers/customerAggrStatsGraphReducers';
import { connectedClientsGraphReducer } from './graphReducers/connectedClientsGraphReducers';
import {
	switchNetworkReducer,
	ipv4NetworkReducer,
	ipv4AddReducer,
	ipv4DeleteReducer,
	editIpv4Reducer,
	ipv6NetworkReducer,
	ipv6AddReducer,
	ipv6DeleteReducer,
	editIpv6Reducer,
	ipv6ManagementReducer,
	ipv6ManagementAddReducer,
	ipv6ManagementDeleteReducer,
	editIpv6ManagementReducer,
} from './switchConfigurationReducers/networkReducer';
import {
	planListReducer,
	planDeleteReducer,
	planReducer,
	planAddReducer,
	planAddModalReducer,
	editValueReducer,
	planEditModalReducer,
	planEditReducer,
} from './plansReducers';
import {
	splashListReducer,
	splashAddReducer,
	splashEditReducer,
	splashDeleteReducer,
} from './splashpagesReducers';
import {
	voucherListReducer,
	voucherAddModalReducer,
	voucherAddReducer,
	voucherDeleteReducer,
	voucherSelectedReducer,
	voucherCodeModalReducer,
} from './voucherReducers';
import { countryCodesReducer } from './countryCodeReducers';
import { timeZoneReducer } from './timeZoneReducer';
import {
	emailListReducer,
	adminEmailApprovalAddModalReducer,
	adminEmailApprovalAddReducer,
	adminEmailApprovalDeleteReducer,
	adminEmailApprovalSelectedReducer,
	adminEmailApprovalEditReducer,
	adminEmailApprovalEditModalReducer,
	emailValueReducer,
	newPasswordReducer,
	superAdminValueReducer,
} from './adminEmailApprovalReducers';
import {
	licenseListReducer,
	licenseUpdateReducer,
	uploadLicenseReducer,
} from './licenseManagement/licenseReducer';
import {
	switchAddReducer,
	switchApiReducer,
	switchDeleteReducer,
	switchTriggerReducer,
	moveSwitchReducer,
	switchNetworkApiReducer,
} from './switchReducers';
import {
	captivePortalsListReducer,
	captivePortalEditReducer,
	captivePortalDeleteReducer,
	captivePortalSelectReducer,
	captivePortalAddReducer,
	captivePortalEditStateReducer,
} from './captivePortalsReducers';

import {
	historicalAlarmsReducer,
	switchAlarmsEventListReducer,
} from './maintainance/historicalAlarmsReducer';
import { alarmEventsReducer } from './maintainance/alarmEventsReducer';
import {
	ackActiveAlarmsReducer,
	activeAlarmsReducer,
	activeAlarmsCriticalReducer,
	activeAlarmsMajorReducer,
	activeAlarmsMinorReducer,
	adminAccountDetailsReducer,
	devicesAlarmsCountReducer,
} from './maintainance/activeAlarmsReducer';
import { switchQueryApiSlice } from '../actions/switches/switchApiQuery';

import {
	basicSettingsReducer,
	basicSettingsUpdateReducer,
} from './switchConfigurationReducers/basicSettingsReducers';
import { poeSettingsReducer } from './switchConfigurationReducers/poeSettingsReducer.js';
import { generalConfigReducer } from './maintainance/alarmConfiguration/generalConfigReducer';
import { deviceConfigReducer } from './maintainance/alarmConfiguration/deviceConfigurationReducer';
import { networkConfigReducer } from './maintainance/alarmConfiguration/networkConfigurationReducers';
import { systemConfigReducer } from './maintainance/alarmConfiguration/systemConfigurationReducer';
import {
	cliClientReducer,
	interfaceListReducer,
	rogueApActionReducer,
	rogueApListReducer,
} from './groupConfigurationReducers/groupConfigurationReducers';

import {
	linkAggReducer,
	updateLinkAggReducer,
} from './switchConfigurationReducers/linkAggregationReducer';
import {
	portMirrorReducer,
	updatePortMirroringReducer,
} from './switchConfigurationReducers/portMirroringReducer';
import {
	alarmReportEditReducer,
	alarmsReportListKpiReducer,
	alarmsReportListReducer,
	deleteAlarmReportReducer,
} from './maintainance/alarmsReportReducer';
import { webSocketReducer } from './webSocketReducer';
import {
	reportsParamIntervalListReducer,
	reportsParamPeriodListReducer,
	reportsParamTypeListReducer,
} from './maintainance/reportsParamReducer';
import {
	announcementBannerCloseTriggerReducer,
	maintainanceInstanceListReducer,
} from './maintenanceInstanceReducer';
import { SwitchModelCountReducer } from './graphReducers/SwitchGraphReducers';

import {
	accessPointRadioSettingDataReducer,
	getDeviceModelsReducer,
	radioSetting24ListReducer,
	radioSetting5GhzListReducer,
	radioSetting6ListReducer,
	radioSettingAtcpReducer,
	radioSettingDataReducer,
	radioSettingListReducer,
	radioSettingWipsReducer,
	tipRadioReducer,
} from './radioSettingReducer';
import { siteHiSenseStatsQueryGraphReducer } from './graphReducers/siteHiSenseStatsQueryGraphReducers';
import { groupConnectedClientsGraphReducer } from './graphReducers/groupConnectedClientsGraphReducers';
import { databaseShReducer } from './maintainance/systemHealth/databaseReducers';
import {
	apisShReducer,
	pcReducer,
} from './maintainance/systemHealth/apisReducers';
import { dockerRegistryShReducer } from './maintainance/systemHealth/dockerRegistryReducers';
import { kubeNodesShReducer } from './maintainance/systemHealth/kubeNodesReducers';
import { rabbitmqNodesShReducer } from './maintainance/systemHealth/rabbitmqNodesReducers';
import { redisNodesShReducer } from './maintainance/systemHealth/redisNodesReducers';
import { kubePodsShReducer } from './maintainance/systemHealth/kubePodsReduces';
import { ntpSyncShReducer } from './maintainance/systemHealth/ntpSyncReducers';
import { nodeStatusReducer } from './maintainance/systemHealth/nodeStatusReducers';
import { pcsShReducer } from './maintainance/systemHealth/pcsReducers';
import { etcdShReducer } from './maintainance/systemHealth/etcdReducers';
import { lsyncdShReducer } from './maintainance/systemHealth/lsyncdReducers';
import { forgotPasswordReducers } from './forgotPasswordReducers';
import { siteAggrStatsReducer } from './graphReducers/siteAggrStatsQueryGraphReducers';
import { homeDashboardStatsReducer } from './homeDashboard/homeDashboardReducers';
import { groupDashboardStatsReducer } from './groupDashStatsReducer';
import { apModalAndFirmwareDistGraphReducer } from './graphReducers/apModalAndFirmwareDistReducers';
import {
	apDashBwReducer,
	groupDashBwReducer,
	homeDashBwReducer,
} from './graphReducers/dataBandwidthGraphReducer';
import { mapViewReducer } from './mapViewReducer';
import { clientSessionListReducer } from './clientSessionsReducers';
import { apSessionDurationReducer, apCpuReducer, uplinkRateGraphReducer, downlinkRateGraphReducer } from './graphReducers/sessionDurationsGraphReducer';
import {
	apStatusReducer,
	switchStatusReducer,
	groupStatusReducer,
	alarmStatusReducer,
	clientStatusReducer,
	switchAlarmStatus,
	radioStatusReducer,
	subSiteStatusReducer,
	ssidStatusReducer,
} from './scrollExpandListViewReducers';
import { routerLatchingTimeReducer } from './graphReducers/latchingTimeGraphReducers';
import { routerAggStatsReducer } from './graphReducers/routerAggrStatsGraphReducers';
import { routerCpuAndMemoryUtilisationReducer } from './graphReducers/routerCPUandMemoryUtilisationGraphReducers';
import { clientStatsGraphReducer } from './graphReducers/clientStatsGraphReducers';
import { clientStatsAndEventGraphReducer } from './graphReducers/clientStatsAndEventGraphReducers';
import {
	apGroupSSIDReducer,
	apGroupSsidTriggerReducer,
} from './apGroupSsidReducer';
import { widsReportListReducer } from './maintainance/widsReportReducer';
import { aprecomDetailsReducer } from './graphReducers/aprecomDetailsReducers';
import { aprecomSiteListReducer } from './graphReducers/aprecomSiteListReducers';
import { ssidLoadGraphReducer } from './graphReducers/ssidLoadGraphReducers';
import { homeDashboardGraphReducer } from './graphReducers/homeDashboardGraphReducers';
import { routerActiveQOEGraphReducer } from './graphReducers/routerActiveQOEGraphReducers';
import { radioPerformanceGraphReducer } from './graphReducers/radioPerformanceGraphReducers';
import { activityBannerReducer } from './activityBannerReducers';
import { switchDashDownloadReducer } from './switchReducers';
import { ApDashDownloadReducer } from './accessPointReducers';
import { clientDashDownloadReducer } from './clientReducers';
import { dashboardReducer } from './dashboardLabelReducers';
import { accessControlQueryApiSlice } from '../pages/systemSettings/globalProfile/accessControls/query';
import { apDashboardReducer } from './graphReducers/apDashboardReducers';
import { tipGroupSSIDReducer } from './tipGroupSSIDReducer.js';
import { siteApsDataUsageGraphReducer } from './graphReducers/siteApDataUsageReducer.js';
import { siteApClientsGraphReducer } from './graphReducers/siteApClientsGraphReducer.js';
import bulkReducer from './bulkStatusReducers.js';
import { decryptData } from '../utils/crypto';
import {
    floorPlanListReducer,
    floorPlanCreateReducer,
    floorPlanUpdateReducer,
    floorPlanDeleteReducer,
} from './floorPlanReducers';
import {aprecomIssuesSummaryReducer} from '../reducers/graphReducers/aprecomIssuesSummaryReducers.js';
import { iocpCaptivePortalsReducer, roleBasedListReducer } from './globalProfiles/roleBasedAccessReducers.js';
import {sidebarLockReducer} from './sidebarLockReducer.js';
import { snmpListReducer } from './globalProfiles/snmpReducer.js';
import { bullkActionTasksReducer } from './maintainance/bulkActionReducer/bulkActionTasksReducer.js';
import { snapshotHistoryListReducer } from './maintainance/snapshotHistoryReduces.js';
import { systemBackupReducer } from './maintainance/systemBackup/systemBackupReducer.js';
import { meshTopologyReducer } from './graphReducers/meshTopologyReducer.js';
import { apInsightsReducer, clientInsightsReducer } from './insightsReducer.js';

/**
 * Combines multiple reducers into a single reducer function.
 *
 * This is typically used in Redux to manage different parts of the state independently.
 */
const reducer = combineReducers({
	userLogin: userLoginReducer,
	logoutMessage: userLogoutReducer,
	emailMessage: emailVerifyReducer,
	otpMessage: OtpVerifyReducer,
	otpVerify: otpVerificationReducer,
	groupList: groupListReducer,
	groupCountryList: groupCountryListBySiteReducer,
	addGroup: groupAddReducer,
	bulkGroup: bulkGroupAddReducer,
	deleteGroup: groupDeleteReducer,
	macACL: macAclListReducer,
	vlanPool: vlanPoolListReducer,
	siteBackup: siteBackupReducer,
	acsScheduler: acsSchedulerListReducer,
	acsEditScheduler: acsScheduleEditReducer,
	acsAddScheduler: acsScheduleAddReducer,
	ssidScheduler: ssidSchedulerListReducer,
	ssidEditScheduler: ssidScheduleEditReducer,
	ssidAddScheduler: ssidScheduleAddReducer,
	accessPoint: accessPointListReducer,
	SSID: SSIDReducer,
	userList: userListReducer,
	tenantList: tenantListReducer,
	tenantAdd: tenantAddReducer,
	tenantNotification: tenantNotificationReducer,
	tenantDelete: tenantDeleteReducer,
	tenantDownload: tenantDownloadReducer,
	tenantEdit: tenantEditReducer,
	hostList: cnmsHostListReducer,
	notificationTenant: notificationTenantReducer,
	auditLogList: auditLogListReducer,
	contentTypeList: contentTypeListReducer,
	userDelete: userDeleteReducer,
	userSuspend: userSuspendReducer,
	userAdd: userAddReducer,
	user: userReducer,
	userEdit: userEditReducer,
	adminPasswordUpdate: changePasswordReducer,
	adminDetails: adminDetailReducer,
	roleList: roleListReducer,
	rolePermissionsList: rolePermissionsReducer,
	roleDetails: roleDetailsReducer,
	roleDelete: roleDeleteReducer,
	roleAdd: roleAddReducer,
	roleEdit: roleEditReducer,
	role: roleReducer,
	topology: topologyReducer,
	topologyModals: topologyModalsReducer,
	atfProfile: atfProfileListReducer,
	atfProfileEdit: atfProfileEditReducer,
	breadcrumbsList: breadcrumbsReducer,
	multiPSK: multiPSKListReducer,
	eogreReducer: eogreReducer,
	natProfile: natProfileReducer,
	aaaServer: aaaServerReducer,
	aaaServerAdd: aaaServerAddReducer,
	aaaServerEdit: aaaServerEditReducer,
	firmwareManagement: firmwareManagementListReducer,
	firmwareList: firmwareListReducer,
	tourGuide: tourGuideReducer,
	tourGuideStep: tourGuideStepReducer,
	hiSenseGraph: hiSenseGraphReducer,
	planList: planListReducer,
	planDelete: planDeleteReducer,
	plan: planReducer,
	planAdd: planAddReducer,
	planAddModal: planAddModalReducer,
	planEditModal: planEditModalReducer,
	planEdit: planEditReducer,
	editValue: editValueReducer,
	splashList: splashListReducer,
	splashAdd: splashAddReducer,
	splashEdit: splashEditReducer,
	splashDelete: splashDeleteReducer,
	voucherList: voucherListReducer,
	countryCodesReducer: countryCodesReducer,
	timeZones: timeZoneReducer,
	voucherAddModal: voucherAddModalReducer,
	voucherAdd: voucherAddReducer,
	voucherDelete: voucherDeleteReducer,
	voucherSelected: voucherSelectedReducer,
	emailList: emailListReducer,
	adminEmailApprovalAddModal: adminEmailApprovalAddModalReducer,
	adminEmailApprovalAdd: adminEmailApprovalAddReducer,
	adminEmailApprovalDelete: adminEmailApprovalDeleteReducer,
	adminEmailApprovalSelected: adminEmailApprovalSelectedReducer,
	adminEmailApprovalEdit: adminEmailApprovalEditReducer,
	adminEmailApprovalEditModal: adminEmailApprovalEditModalReducer,
	emailValue: emailValueReducer,
	newPassword: newPasswordReducer,
	superAdminValue: superAdminValueReducer,
	connectedClientsGraph: connectedClientsGraphReducer,
	voucherCodeModal: voucherCodeModalReducer,
	licenseList: licenseListReducer,
	customerAggrStatsReducer: customerAggrStatsReducer,
	aprecomSiteListReducer: aprecomSiteListReducer,
	clientListReducer: clientListReducer,
	switchApiReducer,
	switchNetworkApiReducer,
	switchAddReducer,
	switchDeleteReducer,
	uploadLicense: uploadLicenseReducer,
	updateLicense: licenseUpdateReducer,
	captivePortalsList: captivePortalsListReducer,
	captivePortalsEdit: captivePortalEditReducer,
	captivePortalEditState: captivePortalEditStateReducer,
	captivePortalDelete: captivePortalDeleteReducer,
	captivePortalSelect: captivePortalSelectReducer,
	captivePortalAdd: captivePortalAddReducer,
	networkReducer: switchNetworkReducer,
	bulkAddAp: bulkAddApReducer,
	historicalAlarmsReducer,
	alarmEventsReducer,
	activeAlarmsReducer,
	activeAlarmsCriticalReducer,
	activeAlarmsMajorReducer,
	activeAlarmsMinorReducer,
	deleteAp: accessPointDeleteReducer,
	addAp: accessPointAddReducer,
	updateAp: accessPointUpdateReducer,
	[switchQueryApiSlice.reducerPath]: switchQueryApiSlice.reducer,
	[accessControlQueryApiSlice.reducerPath]:
		accessControlQueryApiSlice.reducer,
	ackActiveAlarmsReducer,
	basicSettingsReducer,
	poeSettingsReducer,
	aaaServerTrigger: aaaServerTriggerReducer,
	linkAggReducer,
	portMirrorReducer,
	generalData: generalConfigReducer,
	deviceData: deviceConfigReducer,
	networkData: networkConfigReducer,
	systemData: systemConfigReducer,
	alarmsReportList: alarmsReportListReducer,
	deleteAlarmReport: deleteAlarmReportReducer,
	webSocket: webSocketReducer,
	reportsParamTypeList: reportsParamTypeListReducer,
	reportsParamIntervalList: reportsParamIntervalListReducer,
	reportsParamPeriodList: reportsParamPeriodListReducer,
	updateLinkAggReducer,
	updatePortMirroringReducer,
	maintenanceInstanceList: maintainanceInstanceListReducer,
	announcementBannerCloseTrigger: announcementBannerCloseTriggerReducer,
	cliClientReducer,
	switchTrigger: switchTriggerReducer,
	apTrigger: apTriggerReducer,
	ssidTrigger: ssidTriggerReducer,
	groupTrigger: groupTriggerReducer,
	userTrigger: userTriggerReducer,
	switchModelCount: SwitchModelCountReducer,
	groupListBySiteReducer,
	moveApReducer,
	radioSetting: radioSettingListReducer,
	siteHiSenseStatsQueryGraphReducer: siteHiSenseStatsQueryGraphReducer,
	groupConnectedClientsGraphReducer: groupConnectedClientsGraphReducer,
	databaseSh: databaseShReducer,
	apisSh: apisShReducer,
	packetCapture: pcReducer,
	dockerRegistrySh: dockerRegistryShReducer,
	kubeNodesSh: kubeNodesShReducer,
	rabbitmqNodesSh: rabbitmqNodesShReducer,
	redisNodesSh: redisNodesShReducer,
	kubePodsSh: kubePodsShReducer,
	ntpSyncSh: ntpSyncShReducer,
	clientDashboardReducer,
	nodeStatusSh: nodeStatusReducer,
	pcsSh: pcsShReducer,
	etcdSh: etcdShReducer,
	lsyncdSh: lsyncdShReducer,
	forgotPassword: forgotPasswordReducers,
	siteAggrStats: siteAggrStatsReducer,
	homeDashboardStatsReducer,
	switchDashDownloadReducer,
	ApDashDownloadReducer,
	clientDashDownloadReducer,
	groupDashboardStatsReducer,
	apModalFirmDist: apModalAndFirmwareDistGraphReducer,
	homeDashBwReducer,
	apDashBwReducer,
	apSessionDurationReducer,
	apCpuReducer,
	groupDashBwReducer,
	mapView: mapViewReducer,
	clientSessionList: clientSessionListReducer,
	basicSettingsUpdateReducer,
	apStatus: apStatusReducer,
	switchStatus: switchStatusReducer,
	radioStatus: radioStatusReducer,
	groupStatus: groupStatusReducer,
	alarmStatus: alarmStatusReducer,
	clientStatus: clientStatusReducer,
	swithAlaramStatus: switchAlarmStatus,
	subSiteStatus: subSiteStatusReducer,
	ssidStatus: ssidStatusReducer,
	routerLatchingTime: routerLatchingTimeReducer,
	routerAggStats: routerAggStatsReducer,
	routerCpuAndMemory: routerCpuAndMemoryUtilisationReducer,
	radioSettingData: radioSettingDataReducer,
	tipRadioData: tipRadioReducer,
	radioSettingAtcp: radioSettingAtcpReducer,
	radioSettingWips: radioSettingWipsReducer,
	accessPointRadioSettingData: accessPointRadioSettingDataReducer,
	deviceModels: getDeviceModelsReducer,
	clientAggStats: clientStatsGraphReducer,
	clientStatsEvents: clientStatsAndEventGraphReducer,
	groupListHomeAdd: groupListHomeAddReducer,
	createTenant: createTenantReducer,
	viewMultiPskReducer,
	apGroupSSIDReducer,
	apGroupSsidTriggerReducer,
	networkIpv4Reducer: ipv4NetworkReducer,
	ipv4AddReducer,
	ipv4DeleteReducer,
	editIpv4Reducer,
	networkIpv6Reducer: ipv6NetworkReducer,
	ipv6AddReducer,
	ipv6DeleteReducer,
	editIpv6Reducer,
	ipv6ManagementReducer,
	ipv6ManagementAddReducer,
	ipv6ManagementDeleteReducer,
	editIpv6ManagementReducer,
	moveSwitchReducer: moveSwitchReducer,
	widsReportList: widsReportListReducer,
	criticalAlarmTriggerReducer,
	alarmReportEdit: alarmReportEditReducer,
	aprecomInfo: aprecomDetailsReducer,
	interfaceListReducer,
	rogueApList: rogueApListReducer,
	rogueApAction: rogueApActionReducer,
	natAddTrigger: natAddTriggerReducer,
	alarmsReportListKpiReducer,
	ssidLoadGraph: ssidLoadGraphReducer,
	homeDashboardGraphReducer,
	routerActiveQOEGraphReducer,
	adminAccountDetailsReducer,
	devicesAlarmsCountReducer,
	deviceListBySite: deviceListBySiteReducer,
	apswitchList: apSwitchListReducer,
	radioPerformanceGraphReducer,
	activityBannerReducer,
	switchAlarmsEventListReducer,
	switchFirmwareListReducer,
	dashboard: dashboardReducer,
	accessPointDashboardReducer,
	apDashboardReducer,
	tipGroupSSIDReducer,
	firmwareNavigatiorReducer,
	signupDataReducer,
	deviceListReducer,
	siteApsDataUsageGraphReducer,
	siteApClientsGraphReducer,
	uplinkRateGraphReducer,
	downlinkRateGraphReducer,
	bulkStatus: bulkReducer,
	configAuditListReducer,
	sidebarSearchReducer,
    floorPlanList: floorPlanListReducer,
	floorPlanCreate: floorPlanCreateReducer,
	floorPlanUpdate: floorPlanUpdateReducer,
	floorPlanDelete: floorPlanDeleteReducer,
	clientModalsReducer,
	issuesSummaryReducer : aprecomIssuesSummaryReducer,
	roleBasedListReducer,
	iocpCaptivePortalsReducer,
	sidebarLock: sidebarLockReducer,
	nestedChildList: nestedChildListBySiteReducer,
	snmpListReducer,
	bullkActionTasksReducer,
	natAdd: natAddProfileReducer,
	natEdit: natEditProfileReducer,
	snapshotHistoryListReducer,
	apSnapshotNavigateReducer,
	ssidTemplateList: SsidTemplateListReducer,
	viewModeReducer,
	refreshGroupSummary: refreshGroupSummaryReducer,
	systemBackup: systemBackupReducer, 
	radioSetting5GhzListReducer,
	radioSetting24ListReducer,
	radioSetting6ListReducer,
	meshTopologyReducer,
	topologyClientListReducer,
	apInsightsReducer,
	clientInsightsReducer
});

/**
 * Retrieves user information from local storage, if available.
 *
 * This variable is used to initialize the user login state with data from local storage,
 * allowing for persistent user login status across page reloads.
 */
const userInfoFromStorage = decryptData(localStorage.getItem('userInfo'))
	? JSON.parse(decryptData(localStorage.getItem('userInfo')))
	: null;

const logoutMessageFromStorage = localStorage.getItem('userlogout')
	? localStorage.getItem('userlogout')
	: null;

/**
 * Initial state object for the Redux store.
 *
 * This object defines the initial state of the Redux store, including the user login state
 * initialized with user information retrieved from local storage, if available.
 */
const initialState = {
	userLogin: { userInfo: userInfoFromStorage },
	logoutMessage: { logoutMessage: logoutMessageFromStorage },
};

/**
 * Middleware array for enhancing Redux store functionality.
 *
 * This array contains middleware functions, such as Redux Thunk, used to extend the capabilities
 * of the Redux store, enabling asynchronous actions and side effects.
 */
const middleware = [thunk, clientDashboardPersistMiddleware];

/**
 * Redux store instance.
 *
 * This variable creates a Redux store with the specified reducer, initial state, and middleware,
 * and enhances it with development tools if available (e.g., Redux DevTools Extension).
 */
const store = createStore(
	reducer,
	initialState,
	// composeWithDevTools(applyMiddleware(...middleware))
	// applyMiddleware(...middleware)
	typeof window !== 'undefined' &&
		typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
		? composeWithDevTools(
				applyMiddleware(
					...middleware,
					switchQueryApiSlice.middleware,
					accessControlQueryApiSlice.middleware
				)
		  )
		: applyMiddleware(
				...middleware,
				switchQueryApiSlice.middleware,
				accessControlQueryApiSlice.middleware
		  )
);

export default store;
